export default "__VITE_ASSET___7pCIyOg__"